import React, { useState } from 'react'
import { Card, Button, Alert, message } from 'antd'
import { CloudDownloadOutlined, DatabaseOutlined } from '@ant-design/icons'
import { api, ApiError } from '@/services/api'

const BackupPage: React.FC = () => {
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async () => {
    setDownloading(true)
    try {
      await api.downloadBackupSql()
      message.success('Backup downloaded')
    } catch (err) {
      message.error(err instanceof ApiError ? err.message : 'Failed to generate the backup')
    } finally {
      setDownloading(false)
    }
  }

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 className="page-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <DatabaseOutlined style={{ color: '#001A4D' }} /> Database Backup
        </h2>
        <p className="page-subtitle">
          Download a full SQL backup of the live database — every table's schema and data,
          as a single restorable .sql file.
        </p>
      </div>

      <Card style={{ maxWidth: 640 }}>
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 20 }}
          message="What's in the file"
          description="One CREATE TABLE IF NOT EXISTS and a set of INSERT statements per table, for every table in the database — enough to fully rebuild it from scratch in an empty Postgres database. This can take a little while to generate since it queries every table."
        />
        <Button
          type="primary"
          size="large"
          icon={<CloudDownloadOutlined />}
          loading={downloading}
          onClick={handleDownload}
        >
          {downloading ? 'Generating backup…' : 'Download SQL Backup'}
        </Button>
      </Card>
    </div>
  )
}

export default BackupPage
